module.exports = __webpack_public_path__ + "static/media/share.6b990006.svg";